import { getFirmwaresSelector } from '../../../../../../shared/selectors/get-firmwares-selector/get-firmwares.selector';
import { useAppSelector } from '../../../../../../store/hooks';
import { getActiveMandantIdSelector } from '../../../../../shared/store/selectors/get-active-mandant-id/get-active-mandant-id.selector';
import { getIsAppLoadingSelector } from '../../../../../shared/store/selectors/get-is-app-loading/get-is-app-loading.selector';
import { getFirmwareFiltersSelector } from '../../../../store/selectors/get-firmware-filters/get-firmware-filters.selector';
import { FirmwareTableSelectors } from './models/firmware-table-selectors.model';

export const useGetFirmwareTableSelectors = (): FirmwareTableSelectors => {
  const firmwares = useAppSelector(getFirmwaresSelector);
  const isLoading = useAppSelector(getIsAppLoadingSelector);
  const activeMandantId = useAppSelector(getActiveMandantIdSelector);
  const firmwareFilters = useAppSelector(getFirmwareFiltersSelector);

  const rowsPerPage = firmwareFilters.pagination.size;
  const page = firmwareFilters.pagination.pageNumber;
  const firmwareHeaderFilters = firmwareFilters.header;
  const count = firmwareFilters.pagination.totalCount;

  return {
    firmwares,
    isLoading,
    activeMandantId,
    firmwareFilters,
    page,
    rowsPerPage,
    count,
    firmwareHeaderFilters,
  };
};
